import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import GlobalService from "./global_services";
import {GlobalState} from "./types";

export const fetchConfig = createAsyncThunk(
    'global/fetchConfig',
    async () => GlobalService.getConfig()
);

export const fetchPreferredCurrency = createAsyncThunk(
    'global/fetchPreferredCurrency',
    async () => {
        try {
            return await GlobalService.getPreferredCurrency();
        } catch {
            return null;
        }
    }
);

export const fetchPreferredLanguage = createAsyncThunk(
    'global/fetchPreferredLanguage',
    async () => {
        try {
            return await GlobalService.getPreferredLanguage();
        } catch {
            return null;
        }
    }
);

export const omniSearch = createAsyncThunk(
    "global/omniSearch",
    async (query: any) => {
        const data = await GlobalService.omniSearch(query);
        return {
            query,
            top_result: data.top_result || null,
            songs: data.songs || [],
            artists: data.artists || [],
            albums: data.albums || [],
            community_contributions: data.community_contributions || [],
            community_contribution_requests: data.community_contribution_requests || [],
            choirs: data.choirs || [],
            reels: data.reels || []
        };
    }
);

const initialState: GlobalState = {
    config: null,
    preferredCurrency: null,
    preferredLanguage: null,
    loading: false,
    error: null,
    searchQuery: '',
    searchLoading: false,
    searchError: null,
    searchResults: null
};

export const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        clearSearchResults(state) {
            state.searchResults = null;
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchConfig.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchConfig.fulfilled, (state, action) => {
            state.loading = false;
            state.config = action.payload;
        });
        builder.addCase(fetchConfig.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
        });
        builder.addCase(fetchPreferredCurrency.fulfilled, (state, action) => {
            state.preferredCurrency = action.payload || null;
        });
        builder.addCase(fetchPreferredCurrency.rejected, (state) => {
            state.preferredCurrency = null;
        });
        builder.addCase(fetchPreferredLanguage.fulfilled, (state, action) => {
            state.preferredLanguage = action.payload || null;
        });
        builder.addCase(fetchPreferredLanguage.rejected, (state) => {
            state.preferredLanguage = null;
        });

        // Omni Search
        builder.addCase(omniSearch.pending, (state) => {
            state.searchLoading = true;
            state.searchError = null;
        })
            .addCase(omniSearch.fulfilled, (state, action) => {
                state.searchLoading = false;
                state.searchQuery = action.payload.query;
                state.searchResults = {
                    top_result: action.payload.top_result,
                    songs: action.payload.songs,
                    artists: action.payload.artists,
                    albums: action.payload.albums,
                    community_contributions: action.payload.community_contributions,
                    community_contribution_requests: action.payload.community_contribution_requests,
                    choirs: action.payload.choirs,
                    reels: action.payload.reels
                };
            })
            .addCase(omniSearch.rejected, (state, action) => {
                state.searchLoading = false;
                state.searchError = action.error.message || "Search failed";
            });
    }
});

export const {clearSearchResults} = globalSlice.actions;
export default globalSlice.reducer;
